import { render, staticRenderFns } from "./Knowbtn1.vue?vue&type=template&id=77cf82f3&scoped=true&"
import script from "./Knowbtn1.vue?vue&type=script&lang=js&"
export * from "./Knowbtn1.vue?vue&type=script&lang=js&"
import style0 from "./Knowbtn1.vue?vue&type=style&index=0&id=77cf82f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cf82f3",
  null
  
)

export default component.exports